import clsx from "clsx";

import {
  Box,
  CircularProgress,
  LinearProgress,
  Tooltip,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  circular: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1),
  },
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.65)",
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 1,
  },
}));

type Props = {
  children?: any;
  loading?: boolean;
  progress?: any;
  overlay?: any;
};

export default function Loader({
  children,
  loading,
  progress,
  overlay,
}: Props) {
  const classes = useStyles();
  const hasProgress = !isNaN(progress);

  if (loading || (hasProgress && progress < 100)) {
    let loader = hasProgress ? (
      <LinearProgress value={progress} variant="determinate" />
    ) : (
      <CircularProgress />
    );

    if (hasProgress) {
      loader = (
        <Tooltip title={`${Math.floor(progress * 100) / 100}%`}>
          {loader}
        </Tooltip>
      );
    }

    const className = clsx({
      [classes.circular]: !hasProgress,
      [classes.overlay]: overlay,
    });

    return (
      <Box position="relative">
        <div className={className}>{loader}</div>
        {overlay && (children || null)}
      </Box>
    );
  }

  return children || null;
}
